module.exports = __webpack_public_path__ + "static/media/stamp_5.40c1e442.png";